/**
 * ClipThisButton
 *
 * The capture affordance for snippets (docs/design/SNIPPETS-SPEC.md "Capture
 * flow"). Visible only when 2+ chords are selected — the same visibility
 * rule family as MovesPalette (exactly 1 selected), so the two never show
 * together and can safely share the same top-right dock.
 */
import React from 'react';
import styles from './ClipThisButton.module.css';

interface ClipThisButtonProps {
  /** Number of currently selected chords; hidden below 2. */
  count: number;
  onClip: () => void;
}

const ClipThisButtonComponent: React.FC<ClipThisButtonProps> = ({ count, onClip }) => {
  if (count < 2) return null;

  return (
    <div className={styles.dock}>
      <button type="button" className={styles.button} onClick={onClip}>
        clip this
        <span className={styles.count}>{count} chords</span>
      </button>
    </div>
  );
};

ClipThisButtonComponent.displayName = 'ClipThisButton';

export const ClipThisButton = React.memo(ClipThisButtonComponent);
